<ng-container *ngIf="queryBuilder">
  <ng-container *ngIf="currentView == 'data'">
    <ng-container *ngIf="!hideDatasets">
      <div class="ui basic segment">
        <h4>Dataset</h4>
        <p-select
          styleClass="tw-w-full"
          optionLabel="displayName"
          filterBy="displayName"
          [filter]="true"
          [ngModel]="currentDataset"
          [options]="datasetDropdownOptions"
          (onChange)="changeDataset($event.value)"
          [group]="true"
        >
          <ng-template
            let-group
            pTemplate="group"
          >
            <div class="tw-flex tw-items-center">
              <span>{{ group.label }}</span>
            </div>
          </ng-template>
        </p-select>
      </div>

      <div class="ui divider"></div>
    </ng-container>

    <ng-container *ngIf="!hideDimensions">
      <div [class.loading]="loadingDimensions || loadingSchema" class="ui basic query segment">
        <div class="tw-flex tw-justify-between tw-mb-3">
          <h4>Dimensions</h4>
          <div class="tw-flex tw-items-center tw-gap-2">
            <span
              *ngIf="hasIncompatibleDimensionFilters"
              class="tw-text-red-600 fa-solid fa-triangle-exclamation"
              pTooltip="One or more filters are not compatible with one or more selected dimensions."
              tooltipPosition="left"
            ></span>
            <p-button
              *ngIf="!hideAdvancedFilter"
              icon="fa-solid fa-filter"
              severity="secondary"
              [label]="hasFilters ? 'Edit Filters' : 'Add Filters'"
              [outlined]="hasFilters ? false : true"
              (onClick)="toggleAdvancedFilter()"
            ></p-button>
          </div>
        </div>

        <div class="tw-mb-4 tw-flex tw-items-center">
          <p-iconField
            class="tw-flex tw-w-full tw-items-center"
          >
            <input
              pInputText
              type="text"
              placeholder="Search dimensions..."
              class="tw-w-full"
              [formControl]="dimensionFilterControl"
            />
            <p-inputIcon>
              <i class="fa-solid fa-magnifying-glass tw-leading-4 tw-align-middle tw-mb-3"></i>
            </p-inputIcon>
          </p-iconField>
        </div>

        <drag-drop-list
          *ngIf="!loadingSchema && !loadingQuery"
          bagId="dimensions-bag"
          class="dimensions"
          [ngModel]="queryBuilder.query?.dimensions"
          (ngModelChange)="setDimensions($event)"
          [options]="queryBuilder.schema.dimensions"
          [editableOptions]="queryBuilder.editableDimensions()"
          [visibleOptions]="visibleDimensions"
          [canBeGroupedBy]="!disableGroupBy"
          [canOrderResult]="queryBuilder.schema.isFactBased() && !disallowedWidgetTypes.includes(widgetType)"
          (orderBy)="orderByField($event, dimension)"
          [orderState]="order"
          (groupBy)="groupByDimension($event, dimension)"
          [groupByState]="dimensionGroupBy"
        ></drag-drop-list>

        <div *ngIf="!hideDimensionAttributes && propertiesExist(queryBuilder.query?.dimensions)" class="colored attributes">
          <h4>Attributes</h4>

          <properties-list
            [ngModel]="queryBuilder.query?.dimensionProperties"
            (ngModelChange)="setDimensionProperties($event)"
            [options]="queryBuilder.query?.dimensions"
            [canOrderResult]="queryBuilder.schema.isFactBased()"
            (orderBy)="orderByField($event, dimensionProperty)"
            [orderState]="order"
          ></properties-list>
        </div>
      </div>

      <div class="ui divider"></div>
    </ng-container>

    <ng-container *ngIf="!hideMetrics">
      <div
        [class.loading]="loadingSchema"
        class="ui basic query segment"
      >

        <div class="tw-flex tw-justify-between tw-mb-3">
          <h4>Metrics</h4>
          <div class="tw-flex tw-items-center tw-gap-2">
            <span
              *ngIf="hasIncompatibleMetricFilters"
              class="tw-text-red-600 fa-solid fa-triangle-exclamation"
              pTooltip="One or more filters are not compatible with one or more selected dimensions."
              tooltipPosition="left"
            ></span>
            <p-button
              *ngIf="!hideAdvancedFilter"
              icon="fa-solid fa-filter"
              severity="secondary"
              [label]="hasMetricFilters ? 'Edit Filters' : 'Add Filters'"
              [outlined]="hasMetricFilters ? false : true"
              (onClick)="toggleMetricFilters()"
            ></p-button>
          </div>
        </div>

        <div class="tw-mb-4 tw-flex tw-items-center">
          <p-iconField
            class="tw-flex tw-w-full tw-items-center"
          >
            <input
              pInputText
              type="text"
              placeholder="Search metrics..."
              class="tw-w-full"
              [formControl]="metricFilterControl"
            />
            <p-inputIcon>
              <i class="fa-solid fa-magnifying-glass tw-leading-4 tw-align-middle tw-mb-3"></i>
            </p-inputIcon>
          </p-iconField>
        </div>

        <drag-drop-list
          *ngIf="!loadingSchema && !loadingQuery"
          bagId="metrics-bag"
          class="metrics"
          [ngModel]="queryBuilder.query?.metrics"
          (ngModelChange)="setMetrics($event)"
          [options]="queryBuilder.schema.metrics"
          [editableOptions]="queryBuilder.compatibleMetrics()"
          [visibleOptions]="visibleMetrics"
          [canOrderResult]="queryBuilder.schema.isFactBased() && !disallowedWidgetTypes.includes(widgetType)"
          (orderBy)="orderByField($event, metric)"
          [orderState]="order"
        ></drag-drop-list>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="currentView == 'options'">
    <div class="ui basic segment">
      <h4>Sum By</h4>

      <dropdown
      [(ngModel)]="queryBuilder.query.rollup"
      [options]="queryBuilder.schema?.rollups"
      class="fluid selection"
      ></dropdown>
    </div>
  </ng-container>
  <div class="ui divider"></div>
</ng-container>
<ng-container *ngIf="!queryBuilder && (loadingQuery || loadingSchema) && currentView == 'data'">
  <ng-container *ngIf="!hideDatasets">
    <div class="ui basic loading segment">
      <h4>Dataset</h4>
      <dropdown class="fluid search selection"></dropdown>
    </div>
    <div class="ui divider"></div>
  </ng-container>

  <ng-container *ngIf="!hideDimensions">
    <div class="ui basic loading query segment">
      <h4>Dimensions</h4>
      <drag-drop-list class="dimensions"></drag-drop-list>
    </div>
    <div class="ui divider"></div>
  </ng-container>

  <ng-container *ngIf="!hideMetrics">
    <div class="ui basic loading query segment">
      <h4>Metrics</h4>
      <div class="ui input icon fluid small metric-filter">
        <input type="text" placeholder="Search Metrics...">
        <i class="icon search"></i>
      </div>
      <drag-drop-list class="metrics"></drag-drop-list>
    </div>
  </ng-container>
</ng-container>
